<template>
  <div class="personalcenter-mask">
    <div class="main-content">
      <div class="navs-mask">
        <div
          class="nav-item-mask"
          v-for="(item, index) in navs"
          :key="index"
          :class="{'checked-nav': checkedNav.baseIndex === index}"
        >
          <!-- {{checkedNav.baseIndex}}-{{index}} -->
          <div class="nav-item-body" @click="navClickHandler(item, index)">
            <span>
              <b :class="item.icon"></b>
              {{ item.name }}
            </span>
            <i class="fake-arrow" />
          </div>
          <div class="sub-nav-mask">
            <div
              class="sub-nav"
              v-for="(sub, i) in item.childs"
              :key="i"
              :class="{'checked-sub-nav': checkedNav.baseIndex === index && checkedNav.subIndex === i }"
              @click="subnavClickHandler(sub, i)"
              v-if="!(index === 1 && i === 2 && auth_user_type !== 1)"
            >
              <span>{{ sub.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="router-view-mask">
        <!-- <keep-alive> -->
        <router-view />
        <!-- </keep-alive> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getToken } from "./../../../static/js/util.js";
export default {
  name: "PersonalCenter",
  data() {
    return {
      navs: [
        {
          name: "个人中心",
          routeName: "",
          icon: "el-icon-s-custom",
          childs: [
            {
              name: "账号管理",
              routeName: "userAccount"
            },
            // {
            //     name: '订单管理',
            //     routeName: 'userOrder'
            // },
            {
              name: "我的收藏",
              routeName: "userCollection"
            }
          ]
        },
        {
          name: "使用方",
          routeName: "",
          icon: "el-icon-s-opportunity",
          childs: [
            {
              name: "订阅信息流",
              routeName: "accreditFlow"
            },
            {
              name: "文章微授权",
              routeName: "accreditArticle"
            },
            {
              name: "授权主体",
              routeName: "authorizedbody"
            },
            {
              name: "套餐管理",
              routeName: "accreditPackage"
            },
            {
              name: "API控制台",
              routeName: "accreditApiControl"
            }
          ]
        },
        {
          name: "企业主页",
          routeName: "",
          icon: "el-icon-s-opportunity",
          childs: [
            {
              name: "企业成员",
              routeName: "enterpriseMembers"
            },
            // {
            //   name: "企业成员",
            //   routeName: "enterpriseSubaccountownership"
            // },
            {
              name: "企业资料",
              routeName: "enterpriseInformation"
            }
          ]
        }
      ],
      checkedNav: {
        baseIndex: 0,
        subIndex: 0
      }
    };
  },
  computed: {
    auth_user_type() {
      return this.$store.state.userInfo.auth_user_type;
    }
    
  },
  watch: {
    "$store.state.userInfo"(n, o) {
      console.log(n)
      if (this.$store.state.userInfo.auth_user_type == 3) {
        this.navs.splice(2, 1);
      }
    }
    //  auth_user_type(newVal){
    //   //  console.log(1,this.$store.state.userInfo)
    //   console.log('@watch')
    //   console.log(newVal)
    //   if (newVal == 1) {
    //     // this.navs[1].childs[2].push(
    //     //     {
    //     //       name: "授权主体",
    //     //       routeName: "authorizedbody"
    //     //     });
    //         // this.navs[1].childs.splice(2,0,{
    //         //   name: "授权主体",
    //         //   routeName: "authorizedbody"
    //         //   })
    //     console.log(this.navs[1])
    //   }
    //  }
  },
  mounted() {
    
    console.log(123123123, this.$store.state.userInfo.auth_user_type);
    if (this.$store.state.userInfo.auth_user_type == 3) {
        this.navs.splice(2, 1);
      }
    // if (this.$store.state.userInfo.auth_user_type != 1) {
    //   this.navs[1].childs[2]=[];
    // }
  },
  methods: {
    navClickHandler(item, index) {
      if (this.checkedNav.baseIndex === index) {
        return;
      }
      this.checkedNav.baseIndex = index;
      this.checkedNav.subIndex = 0;
      const { routeName } = item.childs[0];
      if (routeName) {
        this.$router.push({
          name: routeName
        });
      }
      console.log(this.checkedNav.baseIndex, index);
    },
    subnavClickHandler(sub, i) {
      if (this.checkedNav.subIndex === i) {
        return;
      }
      this.checkedNav.subIndex = i;
      const { routeName } = sub;
      if (routeName) {
        this.$router.push({
          name: routeName
        });
      }
    },
    initCheckedNav(name) {
      const { checkedNav, navs } = this;
      checkedNav.baseIndex = /user/.test(name)
        ? 0
        : /enterprise/.test(name)
        ? 2
        : 1;
      checkedNav.subIndex = navs[checkedNav.baseIndex].childs.findIndex(e => {
        return e.routeName === name;
      });
    },
    checkUniqueCode() {
      const unique_code = getToken("unique_code");
      if (!unique_code) {
        this.$message({
          message: "登录过期,请重新登录",
          type: "warning"
        });
        this.$store.commit("setUserInfo", "");
        this.$router.replace("/login");
      }
      console.log(unique_code);
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.checkUniqueCode();
    this.initCheckedNav(to.name);
    next();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.checkUniqueCode();
      const { name } = vm.$route;
      vm.initCheckedNav(name);
    });
  }
};
</script>

<style scoped>
.personalcenter-mask {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 40px 0;
  /* background: rgba(240,240,240,1); */
}

.main-content {
  width: 1200px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.navs-mask {
  width: 300px;
}

.nav-item-mask {
  background: rgba(255, 255, 255, 1);
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  /* padding: 10px 0; */
}

.nav-item-body {
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  color: rgba(21, 47, 106, 0.5);
  line-height: 40px;
  cursor: pointer;
  position: relative;
}
.nav-item-body span {
  width: 80px;
  text-align: left;
  display: block;
  padding-left: 110px;
}

.fake-arrow {
  width: 0;
  height: 0;
  border-top: 4px solid #333333;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  border-bottom: 4px solid transparent;
  transition: all 0.3s;
  transform: rotate(0);
  transform-origin: center 0;
  position: absolute;
  top: 18px;
  right: 28px;
}

.sub-nav-mask {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  max-height: 0;
  overflow: hidden;
  transition: all 0.3s;
}

.sub-nav {
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  color: rgba(21, 47, 106, 0.5);
  line-height: 40px;
  cursor: pointer;
}
.sub-nav span {
  text-align: left;
  display: block;
  text-align: center;
  /* width: 80px; */
  /* padding-left: 130px; */
}

.checked-nav .nav-item-body {
  background: #f6f6f6;
  color: rgba(21, 47, 106, 1);
}

.checked-nav .sub-nav-mask {
  max-height: 200px;
}

.checked-nav .fake-arrow {
  transform: rotate(180deg);
}

.checked-sub-nav.sub-nav {
  color: #1966ff;
  background: #fbfbfb;
}

.router-view-mask {
  width: 860px;
}

.sub-nav:hover {
  /* color: #1966FF; */
  background: #fbfbfb;
}
</style>




// WEBPACK FOOTER //
// src/page/personalCenter/personalCenter.vue